function includeBiobarDiv(ignoreDefaultBiobarDiv ? : boolean) : void {
  if(ignoreDefaultBiobarDiv)
    return;

  const biobar = document.createElement('div');
  biobar.id = 'biobar';

  document.body.appendChild(biobar);
}

export default includeBiobarDiv;